import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { GQL_URL } from './Actions/types';

// GraphQL endpoint
const httpLink = createHttpLink({
  uri: `${GQL_URL}`, 
});

// Add authentication headers
const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('token');
  const authType = localStorage.getItem('authtype');

  return {
    headers: {
      ...headers,
      ...(token && { Authorization: `Bearer ${token}` }),
      ...(authType && { authtype: authType }),
    }
  };
});

// Create the Apollo Client instance
const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
      errorPolicy: 'all',
    },
    query: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
    mutate: {
      errorPolicy: 'all',
    },
  },
});

export default apolloClient;



// WEBPACK FOOTER //
// ./src/apolloClient.js